/**
 * vendedor.js
 *
 * - Checkbox "Te ayudo una vendedora?" muestra/oculta el select de vendedoras
 * - El select se filtra en vivo segun la Sede elegida en sede-selector.liquid
 *   (data-sede-select, mismo <form>) + siempre ofrece "Call Center"
 * - Si el checkbox esta marcado, exige elegir una vendedora antes de poder
 *   agregar al carrito (bloquea el submit, mismo patron guard que sede.js).
 *   Si el checkbox NO esta marcado, no bloquea nada — la venta queda "WEB".
 * - Espeja la eleccion como cart attribute "Vendedor" (para Flow / reportes),
 *   igual que sede.js hace con "Sede".
 *
 * Auto-inicializa. Reactivo a shopify:section:load y shopify:block:select
 * para funcionar en el theme editor.
 */
(function () {
  'use strict';

  var CALL_CENTER = 'Call Center';

  var ACCENT_MAP = { 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U', 'Ñ': 'N', 'Ü': 'U' };

  function normalize(str) {
    return (str || '')
      .toString()
      .toUpperCase()
      .replace(/[ÁÉÍÓÚÑÜ]/g, function (c) { return ACCENT_MAP[c]; })
      .trim();
  }

  function updateCartAttribute(value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Vendedor': value || '' } })
    }).catch(function () { /* no bloquear la compra */ });
  }

  function bind(root) {
    if (root.dataset.vendedorBound === '1') return;
    root.dataset.vendedorBound = '1';

    var dataEl = root.querySelector('[data-vendedor-data]');
    var vendedoras = [];
    try { vendedoras = JSON.parse(dataEl.textContent || '[]'); } catch (e) { vendedoras = []; }

    var toggle = root.querySelector('[data-vendedor-toggle]');
    var field = root.querySelector('[data-vendedor-field]');
    var select = root.querySelector('[data-vendedor-select]');
    var error = root.querySelector('[data-vendedor-error]');
    var form = root.closest('form');
    var sedeSelect = form ? form.querySelector('[data-sede-select]') : null;

    function clearInvalid() {
      root.classList.remove('vendedor-selector--invalid');
      if (error) error.hidden = true;
    }

    function renderOptions(sedeValue, keepValue) {
      var previous = keepValue || select.value;
      var normalizedSede = normalize(sedeValue);
      var matches = vendedoras.filter(function (v) {
        return normalizedSede && normalizedSede.indexOf(normalize(v.sucursal)) !== -1;
      });

      var html = '';
      if (!normalizedSede) {
        html += '<option value="">Selecciona primero tu sede</option>';
        select.disabled = true;
      } else {
        html += '<option value="">Selecciona una vendedora</option>';
        matches.forEach(function (v) {
          html += '<option value="' + v.nombre.replace(/"/g, '&quot;') + '">' + v.nombre + '</option>';
        });
        html += '<option value="' + CALL_CENTER + '">' + CALL_CENTER + '</option>';
        select.disabled = false;
      }
      select.innerHTML = html;

      // Mantener la seleccion previa si sigue siendo una opcion valida tras refiltrar
      var stillValid = Array.prototype.some.call(select.options, function (o) { return o.value === previous; });
      select.value = stillValid ? previous : '';
    }

    function setActive(isActive) {
      field.hidden = !isActive;
      if (isActive) {
        renderOptions(sedeSelect ? sedeSelect.value : '');
      } else {
        select.value = '';
        clearInvalid();
        updateCartAttribute('');
      }
    }

    toggle.addEventListener('change', function () {
      setActive(toggle.checked);
    });

    select.addEventListener('change', function () {
      if (select.value) clearInvalid();
      updateCartAttribute(select.value);
    });

    if (sedeSelect) {
      sedeSelect.addEventListener('change', function () {
        if (toggle.checked) renderOptions(sedeSelect.value, select.value);
      });
    }

    // Estado inicial (por si el theme editor re-renderiza con el checkbox ya marcado)
    setActive(toggle.checked);

    function isValid() {
      if (toggle.checked && !select.value) {
        root.classList.add('vendedor-selector--invalid');
        if (error) error.hidden = false;
        try { select.focus(); } catch (er) {}
        return false;
      }
      clearInvalid();
      return true;
    }

    // Guard del submit — bloquea solo si el checkbox esta marcado y no hay vendedora elegida
    if (form && form.dataset.vendedorGuard !== '1') {
      form.dataset.vendedorGuard = '1';

      // Fallback: ver nota equivalente en sede.js.
      form.addEventListener('submit', function (e) {
        if (!isValid()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);

      // Guard real (hoy) — ver nota en assets/product-form.js.
      window.MkFormGuards = window.MkFormGuards || [];
      window.MkFormGuards.push(function (targetForm) {
        if (targetForm !== form) return true;
        return isValid();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-vendedor-selector]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
